/**
 * Dashboard overview servis — agregirani podaci za početnu admin stranicu.
 */
import ApiService from '@/core/api/ApiService';
import { API_ENDPOINTS } from '@/core/api/endpoints';

class DashboardOverviewService {
  /**
   * @param {{ notification_limit?: number }} [payload]
   * @returns {Promise<object>}
   */
  async search(payload = {}) {
    const notificationLimit =
      typeof payload.notification_limit === 'number' ? payload.notification_limit : 10;
    const response = await ApiService.post(API_ENDPOINTS.DASHBOARD.OVERVIEW_SEARCH, {
      notification_limit: notificationLimit,
    });
    return response?.data ?? {};
  }
}

const dashboardOverviewService = new DashboardOverviewService();
export default dashboardOverviewService;
